export const MERCHANT_FULL_ROLE = 'merchant-full';
export const NAME = 'moet-core';

export const CAPS_STATES = {
  NOT_STARTED: 'NOT_STARTED',
  ONGOING: 'LOADING',
  FINISHED: 'FINISHED',
};

export const ONBOARDING_STATUSES_V2 = {
  PRE_ASSESSMENT_PENDING: 'PRE_ASSESSMENT_PENDING',
  NOT_STARTED: 'NOT_STARTED',
  PRODUCTS_SELECTED: 'PRODUCTS_SELECTED',
  TRANSACTION_DETAILS_STARTED: 'TRANSACTION_DETAILS_STARTED',
  TRANSACTIONS_REVIEW_AUTOMATED: 'TRANSACTIONS_REVIEW_AUTOMATED',
  TRANSACTIONS_REVIEW_MANUAL: 'TRANSACTIONS_REVIEW_MANUAL',
  TRANSACTIONS_ENABLED: 'TRANSACTIONS_ENABLED',
  TRANSACTIONS_DISABLED: 'TRANSACTIONS_DISABLED',
  PAYOUT_DETAILS_STARTED: 'PAYOUT_DETAILS_STARTED',
  PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION: 'PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION',
  PAYOUTS_REVIEW_AUTOMATED: 'PAYOUTS_REVIEW_AUTOMATED',
  PAYOUTS_REVIEW_MANUAL: 'PAYOUTS_REVIEW_MANUAL',
  COMPLETED: 'COMPLETED',
  SUSPENDED: 'SUSPENDED',
};

export const ONBOARDING_STATUS_VALUES_V2 = {
  SUSPENDED: -1,
  PRE_ASSESSMENT_PENDING: 0,
  NOT_STARTED: 0.5,
  PRODUCTS_SELECTED: 1,
  TRANSACTIONS_DISABLED: 1.5,
  TRANSACTION_DETAILS_STARTED: 2,
  TRANSACTIONS_REVIEW_AUTOMATED: 3,
  TRANSACTIONS_REVIEW_MANUAL: 4,
  TRANSACTIONS_ENABLED: 5,
  PAYOUT_DETAILS_STARTED: 6,
  PAYOUTS_REVIEW_AUTOMATED: 8,
  PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION: 8.5,
  PAYOUTS_REVIEW_MANUAL: 9,
  COMPLETED: 10,
};

export const PRODUCT_PRICING_TYPES = {
  CHILDREN: 'CHILDREN',
  PARENT: 'PARENT',
};

export const PRODUCT_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  INSTALLED: 'INSTALLED',
  IN_PROGRESS: 'IN_PROGRESS',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
};

export const ACCOUNT_TYPES = {
  IBAN: 'IBAN',
  AU: 'AU_LOCAL',
  GB: 'GB_LOCAL',
  CA: 'CA_LOCAL',
  MX: 'MX_LOCAL',
  US: 'US_LOCAL',
};
export const COUNTRIES_WITH_LOCAL_BANK_ACCOUNT = ['AU', 'CA', 'GB', 'MX', 'US'];
export const COUNTRIES_WITH_BIC = ['AU'];
export const COUNTRIES_WITH_ROUTING_NUMBER = ['CA', 'GB', 'US'];

export const STEP_STATUS = {
  APPROVED: 'APPROVED',
  DONE: 'DONE',
  MANUAL_REVIEW: 'MANUAL_REVIEW',
  NOT_STARTED: 'NOT_STARTED',
  DISABLED: 'DISABLED',
  PENDING: 'PENDING',
  SUSPENDED: 'SUSPENDED',
};

export const ENTITY_TYPE = {
  SOLE_TRADER: 'SOLE_TRADER',
  PARTNERSHIP: 'PARTNERSHIP',
  PUBLIC_LISTED_COMPANY: 'PUBLIC_LISTED_COMPANY',
  PRIVATE_COMPANY: 'PRIVATE_COMPANY',
};
export const ENTITY_TYPES = Object.values(ENTITY_TYPE);

export const ORGANIZATION_ENTITY_TYPE = {
  C_CORP: 'C_CORP',
  S_CORP: 'S_CORP',
  PARTNERSHIP: 'PARTNERSHIP',
  TRUST_ESTATE: 'TRUST_ESTATE',
  INDIVIDUAL: 'INDIVIDUAL',
  SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
  LIMITED_LIABILITY_COMPANY: 'LIMITED_LIABILITY_COMPANY',
  SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY: 'SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY',
};
export const ORGANIZATION_ENTITY_TYPES = Object.values(ORGANIZATION_ENTITY_TYPE);

export const COUNTRIES_WITH_LOOKUP_DATA = ['GB'];

export const CELEBRATION_TIME_WINDOW_SECONDS = 10;
export const CELEBRATION_TIME_WINDOW_CYPRESS_SECONDS = 2;

export const DESIRED_PRODUCT_SORTING = [
  'kp-slice-it-in-4',
  'kp-pay-later',
  'kp-slice-it',
  'kp-pay-now',
  'kco',
  'kco_one',
  'kp_one',
];

export const ONBOARDING_TYPE = {
  // These merchants are onboarded by native partners
  NATIVE: 'NATIVE',
  // These merchants are (typically) onboarded by Salesforce and are managed by a Sales Rep
  MANAGED: 'MANAGED',
  // These merchants don't have any Sales Rep managing their account
  // normally SME's onboarded via MOET
  UNMANAGED: 'UNMANAGED',
  // Merchants onboarded by PSP partners, typically don't have underwriting
  PSP: 'PSP',
  // Merchants onboarded by Moonshot, during product upgrade from v2 to v3
  UPGRADE: 'UPGRADE',
};

export const WIDGET_TYPE = {
  // First step of ONBOARDING_TYPE.MANAGED, we collect risk data and submit it to
  // KYM for PRE_ASSESSMENT_APPROVED underwriting. Typically triggered by Salesforce
  MANAGED_RISK: 'MANAGED_RISK',
  // And we split if the merchant is an SME
  MANAGED_SME_RISK: 'MANAGED_SME_RISK',
  // Second step of ONBOARDING_TYPE.MANAGED, we collect KYC/AML data for PAYOUTS_ENABLED
  MANAGED_KYC: 'MANAGED_KYC',
  // We also have an SME split here
  MANAGED_SME_KYC: 'MANAGED_SME_KYC',
  // Loaded by Native Partners to complete KYC/AML data for PAYOUTS_ENABLED
  NATIVE_KYC: 'NATIVE_KYC',
  // Post onboarding process from KYM/AML recollection
  RECOLLECTION_KYC: 'RECOLLECTION_KYC',
  // Loaded by klarna.com to complete KYC/AML data for PAYOUTS_ENABLED
  UNMANAGED_KYC: 'UNMANAGED_KYC',
  // Used to collect extra documents from merchants
  DOCUMENT_UPLOAD: 'DOCUMENT_UPLOAD',
  // BPC POC
  BPC_POC: 'BPC_POC',
};

export const WIDGET_TYPES = Object.values(WIDGET_TYPE);
export const ONBOARDING_TYPES = Object.values(ONBOARDING_TYPE);
export const MANAGED_ONBOARDING_TYPES = [
  WIDGET_TYPE.MANAGED_KYC,
  WIDGET_TYPE.MANAGED_SME_KYC,
  WIDGET_TYPE.MANAGED_RISK,
  WIDGET_TYPE.MANAGED_SME_RISK,
];

export const WIDGET_ONBOARDING_TYPE_MAP = {
  [WIDGET_TYPE.MANAGED_RISK]: ONBOARDING_TYPE.MANAGED,
  [WIDGET_TYPE.MANAGED_SME_RISK]: ONBOARDING_TYPE.MANAGED,
  [WIDGET_TYPE.MANAGED_KYC]: ONBOARDING_TYPE.MANAGED,
  [WIDGET_TYPE.MANAGED_SME_KYC]: ONBOARDING_TYPE.MANAGED,
  [WIDGET_TYPE.NATIVE_KYC]: ONBOARDING_TYPE.NATIVE,
  [WIDGET_TYPE.UNMANAGED_KYC]: ONBOARDING_TYPE.UNMANAGED,
};
